<app-order-form-header class="shrink-0" [symbol]="symbol()" />

<div class="flex min-h-0 flex-1 flex-col rounded-t-2xl bg-gray-000">
	<div class="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto px-3 pt-3">
		<app-symbol-detail-candle-card
			[showHelp]="false"
			[syncOrderForm]="true"
			[symbolMeta]="symbolMeta()"
			[liveMarketView]="liveMarketView()" />

		<ui-divider />
		<market-depth-best-limit
			[syncOrderForm]="true"
			[depthValues]="depthValues()"
			[previousClosePrice]="previousClosePrice()" />
		<ui-divider />
		<app-order-form-fields />
		<ui-divider />
		<app-order-form-summary />
	</div>
	<div
		class="mb-(--keyboard-offset) shrink-0 px-3 pb-4 pt-3 md:mb-[max(0px,calc(var(--keyboard-offset)-var(--desktop-column-inset-y)))]"
		[class.pb-4]="!keyboardOpen()"
		[class.pb-2]="keyboardOpen()"
		[style.--keyboard-offset]="keyboardBottomOffset() + 'px'">
		<app-order-form-actions [symbolName]="symbol().name" />
	</div>
</div>
